import PropTypes from 'prop-types';
import React from 'react';

import localize from 'components/Localize/Localize';
import { constructPagePath } from 'utils/localeRouteGuide';
import { optionalAttribute } from 'utils/jsx';

import styles from './ProductRatings.css';
import translations from './translations';

const reviewsMap = {
  [`casper-essential`]: `mattress-essential-reviews`,
  [`casper_wave`]: `mattress-premium-reviews`,
  dogBed: `dog-beds-reviews`,
  mattress: `mattress-reviews`,
  pillows: `pillow-reviews`,
  sheets: `sheets-reviews`,
};

const ProductRatings = (props) => {
  const getReviewLink = (product, locale) => {
    return constructPagePath(locale, reviewsMap[product]);
  };

  const renderRatings = () => {
    return (
      props.ratings.map((rating, index) => {
        const widthStyle = {
          width: `${rating.Count / props.totalCount * 100}%`,
        };

        return (
          <div
            className={styles[`item`]}
            key={index}
          >
            <div className={styles[`title`]}>
              {`${rating.RatingValue} ${props.t.star}`}
            </div>
            <div className={styles[`bar`]}>
              <div
                className={styles[`bar-indicator`]}
                style={widthStyle}
              />
            </div>
            <div className={styles[`count`]}>
              {rating.Count}
            </div>
          </div>
        );
      })
    );
  };

  const onClick = optionalAttribute(`onClick`, props.reviewsOnClick, props.reviewsOnClick);
  const href = optionalAttribute(`href`, getReviewLink(props.product, props.locale), !props.reviewsOnClick);

  return (
    <div>
      {renderRatings()}
      <div className={styles[`link-container`]}>
        <a
          {...onClick}
          {...href}
          className={styles[`link`]}
        >
          {props.t.linkCaption}
        </a>
      </div>
    </div>
  );
};

ProductRatings.propTypes = {
  product: PropTypes.string.isRequired,
  ratings: PropTypes.array.isRequired,
  reviewsOnClick: PropTypes.func,
  t: PropTypes.shape({
    linkCaption: PropTypes.string,
    star: PropTypes.string,
  }).isRequired,
  totalCount: PropTypes.number.isRequired,
};

export default localize(ProductRatings, translations);
